import withStyles from '@mui/styles/withStyles';

import styles from './styles';

export const DEFAULT_ILLUSTRATION =
  'https://static.oc-static.com/prod/path/path_teaser_picture_default.jpeg';

const Illustration = ({ classes = {}, className = '', src = DEFAULT_ILLUSTRATION, style = {} }) => (
  <figure
    className={`${classes.illustration} ${className} ${src ? '' : classes.defaultIllustration}`}
    style={{
      ...style,
      backgroundImage: `url(${src || DEFAULT_ILLUSTRATION})`,
    }}
  />
);

export default withStyles(styles)(Illustration);
